import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {PreferenciaDetail} from "./preferencia-detail";

const PreferenciaDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/preferencias');
    }

    return (
        <PreferenciaDetail id={id} onClose={onClose}/>
    )

});

export default PreferenciaDetailPage;